import React from 'react';
import PropTypes from 'prop-types';

import Linkage from '../../common/Linkage';

function ColumnLabel({ width, item, style }) {
  return (
    <div className={`track-label`} style={{ width, zIndex: 50, ...style}}>
      <Linkage label={item.label} to={`/labels/${item.label_slug}/${item.label_id}`} linkClassName={`link-enable`} />
    </div>
  )
}

ColumnLabel.propTypes = {
  width: PropTypes.number.isRequired,
  item: PropTypes.object.isRequired,
  style: PropTypes.object,
}

export default ColumnLabel;
